import styled, { css } from "styled-components";
import getColor from "../../../utils/getColor";
import unit from "../../../utils/unit";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";

// eslint-disable-next-line import/prefer-default-export
export var StyledLinkAtm = styled(Link).withConfig({
  componentId: "sc-1dju8ro-0"
})(function (_ref) {
  var $typography = _ref.$typography,
    $onColor = _ref.$onColor,
    $hasMinWidthFitContent = _ref.$hasMinWidthFitContent,
    theme = _ref.theme;
  return css(["", ";display:inline-block;position:relative;padding-bottom:", ";text-decoration:none;cursor:pointer;&::after{content:\"\";display:block;position:absolute;top:calc(100% - ", ");left:0;width:100%;height:", ";background-color:", ";}&:hover::after{height:", ";}", ""], cssTextAtm({
    typography: $typography,
    onColor: $onColor,
    emphasis: "high"
  }), unit(3), unit(3), unit(2), getColor(theme, "primary"), unit(3), $hasMinWidthFitContent && css(["min-width:fit-content;"]));
});